
import './App.css';
// import List from "./components/List.js"
import Container from './components/Container';

function App() {
  return (
    <div className="App">
    
        <Container />

    </div>
  );
}

export default App;
